import React from 'react';
import { BrowserRouter as Router } from 'mini-react-router-dom';
import { getBootstrapOptions } from '../optionsRegistry';
import { getModuleBasePath } from 'mini-app-module-store/lib/selectors/getModuleBasePath';
import { MiniFrontDoor } from 'mini-front-door';
import { MiniNavigationContextProvider } from 'mini-navigation/lib/MiniNavigationContext';
import { observer } from 'mobx-react-lite';
import { RouteSanitizer } from './RouteSanitizer';
import { ThemeProvider } from 'mini-theme/lib/contexts/ThemeContext';
import { useHandleModuleChange } from '../hooks/useHandleModuleChange';
import { useHandleRouteChangeEvent } from '../hooks/useHandleRouteChangeEvent';
import type { Module } from 'mini-common-schema';
import { LazyCpProdigiFre } from 'mini-mail-copilot-view';
import { CopilotSettingStore } from 'mini-copilot-settings/lib/store/copilotSettingsStore';

export const AppModule = observer(() => {
    const currentModule = useHandleModuleChange();

    if (currentModule !== null) {
        return (
            <ThemeProvider>
                <MiniFrontDoor>
                    <ModuleWrapperWithReactRouter key={currentModule} module={currentModule} />
                    {CopilotSettingStore.isProdigiEnabled && <LazyCpProdigiFre />}
                </MiniFrontDoor>
            </ThemeProvider>
        );
    }

    return null;
});

const ModuleWrapperWithReactRouter = (props: { module: Module }) => {
    const { module } = props;
    return (
        <Router basename={getModuleBasePath(module)}>
            <MiniNavigationContextProvider>
                <RouteSanitizer module={module}>
                    <ModuleWrapper module={module} />
                </RouteSanitizer>
            </MiniNavigationContextProvider>
        </Router>
    );
};

const ModuleWrapper = (props: { module: Module }) => {
    const { module } = props;
    const { renderModule } = getBootstrapOptions(module).appModuleProps;
    useHandleRouteChangeEvent();
    return renderModule();
};
